import apiClient from './apiClient'

/**
 * Get articleInfo
 * @param {object} payload (ArticleId, LanguageCode)
 * @returns 
 */
export const fetchSingleProduct = async (payload) => await apiClient.get('/api/ArticleInfo', payload)